import React, { useEffect, useRef, useState } from "react"

const SLIDES = [
  {
    img: "/banners/slider-electrodomesticos.png",
    heading: "Electrodomésticos al mejor precio",
    text: "Compara y encuentra cerca de ti",
    href: "/productos?categoria=Electrodomésticos",
  },
  {
    img: "/banners/slider-telefonia.png",
    heading: "Teléfonos y accesorios",
    text: "Promociones y planes especiales",
    href: "/productos?categoria=Teléfonos",
  },
  {
    img: "/banners/slider-supermercados.png",
    heading: "Supermercados y bodegones",
    text: "Ahorra comparando precios",
    href: "/productos?categoria=Supermercados",
  },
  {
    img: "/banners/slider-restaurantes.png",
    heading: "Restaurantes cerca de ti",
    text: "Explora por ubicación y calificación",
    href: "/productos?categoria=Restaurantes",
  },
]

export default function HeroSlider({ intervalMs = 5000 }) {
  const [idx, setIdx] = useState(0)
  const timer = useRef(null)
  const touch = useRef({ x: 0, y: 0 })

  const next = () => setIdx((i) => (i + 1) % SLIDES.length)
  const prev = () => setIdx((i) => (i - 1 + SLIDES.length) % SLIDES.length)
  const go = (i) => setIdx(i)

  useEffect(() => {
    timer.current = setInterval(next, intervalMs)
    return () => clearInterval(timer.current)
  }, [intervalMs])

  const onTouchStart = (e) => {
    const t = e.touches[0]
    touch.current = { x: t.clientX, y: t.clientY }
    clearInterval(timer.current)
  }
  const onTouchEnd = (e) => {
    const t = e.changedTouches[0]
    const dx = t.clientX - touch.current.x
    if (Math.abs(dx) > 40) {
      dx < 0 ? next() : prev()
    }
    timer.current = setInterval(next, intervalMs)
  }

  return (
    <div className="relative rounded-3xl overflow-hidden border shadow bg-white">
      {/* Slides */}
      <div
        className="relative w-full h-[220px] sm:h-[320px] md:h-[420px]"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        {SLIDES.map((s, i) => (
          <a
            key={i}
            href={s.href}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === idx ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
            aria-label={s.heading}
          >
            <img
              src={s.img}
              alt={s.heading}
              className="w-full h-full object-cover"
              loading={i === 0 ? "eager" : "lazy"}
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
            <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 text-white max-w-xl">
              <h3 className="text-lg sm:text-2xl md:text-3xl font-extrabold drop-shadow">
                {s.heading}
              </h3>
              <p className="text-xs sm:text-sm opacity-90 drop-shadow">
                {s.text}
              </p>
              <span className="inline-block mt-2 px-3 py-1.5 rounded-lg bg-white text-black text-xs sm:text-sm font-semibold">
                Ver más
              </span>
            </div>
          </a>
        ))}
      </div>

      {/* Controles */}
      <button
        aria-label="Anterior"
        onClick={prev}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full w-9 h-9 grid place-items-center shadow z-20"
      >
        ‹
      </button>
      <button
        aria-label="Siguiente"
        onClick={next}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full w-9 h-9 grid place-items-center shadow z-20"
      >
        ›
      </button>

      {/* Bullets */}
      <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            aria-label={`Ir al slide ${i + 1}`}
            onClick={() => go(i)}
            className={`w-2.5 h-2.5 rounded-full ${
              i === idx ? "bg-white" : "bg-white/60 hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </div>
  )
}
